import { render, staticRenderFns } from "./navigate.vue?vue&type=template&id=70dca88a&"
import script from "./navigate.vue?vue&type=script&lang=js&"
export * from "./navigate.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/home-style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports